var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSayHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.002,
    height: 21.956,
    viewBox: "0 0 29.002 21.956",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3124",
    "data-name": "Group 3124",
    transform: "translate(-9.752 -6.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_64",
    "data-name": "Union 64",
    d: "M4.207,15.459C1.655,13.9.046,11.672,0,9.166-.087,4.268,5.833.167,13.225,0S26.681,3.683,26.768,8.582s-5.831,9-13.224,9.16a18.867,18.867,0,0,1-6.461-.952L.22,19.993Z",
    transform: "translate(11.484 6.961)",
    fill: "#f3f2f0",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M174.421,258.414a2.066,2.066,0,1,1-2.061-1.917A1.992,1.992,0,0,1,174.421,258.414Z",
    transform: "translate(-142.357 -242.127)",
    fill: "#36b549"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M156.412,258.337a2.065,2.065,0,1,1-2.061-1.916A1.992,1.992,0,0,1,156.412,258.337Z",
    transform: "translate(-134.381 -242.096)",
    fill: "#36b549"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M165.463,258.337a2.066,2.066,0,1,1-2.061-1.916A1.992,1.992,0,0,1,165.463,258.337Z",
    transform: "translate(-138.389 -242.096)",
    fill: "#36b549"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSayHover);
export default __webpack_public_path__ + "static/media/say-hover.e5766e2400c06192c159c2ff6f1b5432.svg";
export { ForwardRef as ReactComponent };